import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LandingFooter from '@/modules/Pages/shared/LandingFooter';
import LandingNav from '@/modules/Pages/shared/LandingNav';
import { trackLandingViewOnce } from '@/utils/funnel/waitlistFunnel';
import { AppRoutes } from '@/utils/routes/router';

import '@/modules/Pages/shared/landingPage.css';
import CapacitySection from './sections/CapacitySection';
import GrowthTaxSection from './sections/GrowthTaxSection';
import HiddenRiskSection from './sections/HiddenRiskSection';
import HeroSection from './sections/HeroSection';
import HonestStatusSection from './sections/HonestStatusSection';
import ProductFlowSection from './sections/ProductFlowSection';
import RevenueParadoxSection from './sections/RevenueParadoxSection';
import TeamSection from './sections/TeamSection';

/**
 * Prelaunch waitlist landing page — structure from
 * "ChurnSignal - landing page - prelaunch" copy doc.
 */
export default function LandingPage() {
  const navigate = useNavigate();
  const goToWaitlist = useCallback(() => {
    navigate(AppRoutes.waitlist);
  }, [navigate]);

  useEffect(() => {
    trackLandingViewOnce('/landing');
  }, []);

  return (
    <div className="landing-page landing-grain min-h-screen font-sans relative">
      <div className="relative z-10">
        <LandingNav onWaitlistClick={goToWaitlist} />
        <main>
          <HeroSection onWaitlistClick={goToWaitlist} />
          <RevenueParadoxSection />
          <HiddenRiskSection />
          <GrowthTaxSection />
          <ProductFlowSection />
          <CapacitySection />
          <TeamSection />
          <HonestStatusSection onWaitlistClick={goToWaitlist} />
        </main>
        <LandingFooter />
      </div>
    </div>
  );
}
